import HomeLayout from '../../layouts/Home'
import Home from './Home'

export default HomeLayout(Home)
